import * as React from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer";
import { Button } from "@/components/ui/button";

interface ResponsiveActionMenuProps {
  trigger: React.ReactNode;
  children: React.ReactNode;
  align?: 'start' | 'center' | 'end';
  side?: 'top' | 'right' | 'bottom' | 'left';
  title?: string;
}

export function ResponsiveActionMenu({
  trigger,
  children,
  align = 'end',
  side = 'bottom',
  title = 'Ações'
}: ResponsiveActionMenuProps) {
  const isMobile = useIsMobile();
  const [open, setOpen] = React.useState(false);

  if (isMobile) {
    // Renderizar Drawer (bottom sheet) para mobile
    return (
      <Drawer open={open} onOpenChange={setOpen}>
        <DrawerTrigger asChild>{trigger}</DrawerTrigger>
        <DrawerContent>
          <DrawerHeader>
            <DrawerTitle>{title}</DrawerTitle>
          </DrawerHeader>
          <div className="p-4 space-y-2 pb-8">
            {React.Children.map(children, (child) => {
              if (!React.isValidElement(child)) return null;
              
              // Converter DropdownMenuItem para botão mobile-friendly
              const onClick = child.props.onClick;
              const className = child.props.className || '';
              const isDestructive = className.includes('destructive');
              
              return (
                <Button
                  variant={isDestructive ? "destructive" : "outline"}
                  className="w-full justify-start min-h-[44px] text-left"
                  onClick={() => {
                    onClick?.();
                    setOpen(false);
                  }}
                >
                  {child.props.children}
                </Button>
              );
            })}
          </div>
        </DrawerContent>
      </Drawer>
    );
  }

  // Desktop: Renderizar DropdownMenu normal
  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent align={align} side={side}>
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
